module.exports = __webpack_public_path__ + "eaaac20ecf7ae0dd26e2406cc3f7ab5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_28.jpg
// module id = 1705
// module chunks = 5